import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchDataFromApi } from "../../utils/api";
import CircularProgress from "@mui/material/CircularProgress";

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await fetchDataFromApi(`/api/users/verify-email/${token}`);
     
      // Check if response is null (API error)
      if (!response) {
        setVerificationStatus("error");
        setMessage("Network error. Please check your connection and try again.");
        return;
      }

      // Check the response structure based on your API
      if (response.error === false || response.success === true) {
        setVerificationStatus("success");
        setMessage(response.msg || response.message || "Email verified successfully!");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setVerificationStatus("error");
        setMessage(response.msg || response.message || "Verification failed.");
      }
    } catch (error) {
      console.error("Email verification error:", error);
      setVerificationStatus("error");
      setMessage("Verification failed. Please try again.");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="col-md-6 col-lg-5 shadow p-5 rounded bg-white text-center">
        {verificationStatus === "verifying" && (
          <>
            <CircularProgress size={60} className="mb-3" />
            <h3>Verifying Your Email...</h3>
            <p className="text-muted">Please wait while we verify your email address.</p>
          </>
        )}

        {verificationStatus === "success" && (
          <>
            <div className="mb-4 d-flex justify-content-center">
              <img
                src="https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExcXp3YmdsenR3cDl3cnA0cDd5c25mamJpZjc3d2FpOTkxbm43YXltaSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/K4CCaN833gErkVev8i/giphy.gif"
                alt="Success celebration"
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  display: "block",
                  margin: "0 auto"
                }}
              />
            </div>
            <h3 className="text-success">Email Verified Successfully!</h3>
            <p className="text-muted">{message}</p>
            <p className="text-muted">Redirecting to login page in 3 seconds...</p>
            <button
              className="btn btn-success mt-3"
              onClick={() => navigate("/login")}
            >
              Login Now
            </button>
          </>
        )}

        {verificationStatus === "error" && (
          <>
            <div className="text-danger mb-3">
              <i className="fas fa-times-circle" style={{ fontSize: "60px" }}></i>
            </div>
            <h3 className="text-danger">Verification Failed</h3>
            <p className="text-muted">{message}</p>
            <button
              className="btn btn-primary mt-3"
              onClick={() => navigate("/signup")}
            >
              Register Again
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;